import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ReviewCard = ({ review }) => {
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Icon
        key={index}
        name={index < rating ? 'Star' : 'Star'}
        size={16}
        color={index < rating ? 'var(--color-warning)' : 'var(--color-muted)'}
        className={index < rating ? 'fill-current' : ''}
      />
    ));
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-warm hover:shadow-warm-lg transition-all duration-300">
      <div className="flex items-start gap-4 mb-4">
        <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
          <Image
            src={review?.avatar}
            alt={review?.avatarAlt}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1">
          <h4 className="font-semibold text-foreground">{review?.name}</h4>
          <div className="flex items-center gap-2 mt-1">
            <div className="flex gap-0.5">{renderStars(review?.rating)}</div>
            <span className="text-xs text-muted-foreground">{review?.date}</span>
          </div>
        </div>
        <div className="flex items-center gap-1 text-xs text-muted-foreground">
          <Icon name="MapPin" size={14} />
          <span>{review?.location}</span>
        </div>
      </div>
      <p className="text-sm text-foreground mb-3 leading-relaxed">{review?.comment}</p>
      {review?.category && (
        <div className="flex items-center gap-2 mb-3">
          <span className="text-xs px-2 py-1 rounded-full bg-primary/10 text-primary font-medium">
            {review?.category}
          </span>
          {review?.verified && (
            <div className="flex items-center gap-1 text-xs text-success">
              <Icon name="BadgeCheck" size={14} />
              <span>Verified Purchase</span>
            </div>
          )}
        </div>
      )}
      {review?.images && review?.images?.length > 0 && (
        <div className="grid grid-cols-3 gap-2 mt-4">
          {review?.images?.map((img, index) => (
            <div key={index} className="aspect-square rounded-lg overflow-hidden">
              <Image
                src={img?.url}
                alt={img?.alt}
                className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
              />
            </div>
          ))}
        </div>
      )}
      {review?.response && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="Store" size={16} color="var(--color-primary)" />
            </div>
            <div className="flex-1">
              <p className="text-xs font-semibold text-primary mb-1">Response from Montesanto Bakery</p>
              <p className="text-sm text-muted-foreground">{review?.response}</p>
            </div>
          </div>
        </div>
      )}
      <div className="flex items-center gap-4 mt-4 pt-4 border-t border-border">
        <button className="flex items-center gap-1 text-sm text-muted-foreground hover:text-primary transition-colors">
          <Icon name="ThumbsUp" size={16} />
          <span>Helpful ({review?.helpful})</span>
        </button>
        <button className="flex items-center gap-1 text-sm text-muted-foreground hover:text-primary transition-colors">
          <Icon name="Share2" size={16} />
          <span>Share</span>
        </button>
      </div>
    </div>
  );
};

export default ReviewCard;